const headerStyle = {
    fontSize: "12px",
    background: "#7593F2",
    padding: '6px 10px !important',
    color: '#FFFFFF'
  };
const cellStyles = {
  fontWeight: 800
};

const paradigmTypes = [
  {
    label: 'XPath',
    value: 'XPath'
  },
  {
    label: 'Web',
    value: 'Web'
  }
];

const browserTypes = [
  {
    label: 'Chrome',
    value: 'Chrome'
  },
  {
    label: 'Firefox',
    value: 'Firefox'
  },
  {
    label: 'Opera',
    value: 'Opera'
  }
];

const contextMenu = [
  {
    label: 'Edit',
    value: 'edit',
    hideOnEdit: true
  },
  {
    label: 'Delete',
    value: 'remove'
  }
];

export const validateApplicationsColumns = [
    {
      key: "name",
      display_name: "Application Name",
      cellStyles: { ...cellStyles },
      headerStyles: headerStyle,
      _editConfig: {
        type: 'input'
      }
    },
    {
      key: "paradigm",
      display_name: "Type",
      headerStyles: headerStyle,
      _editConfig: {
        type: 'select',
        options: paradigmTypes
      }
    },
    {
      key: "browser",
      display_name: "Browser",
      headerStyles: headerStyle,
      _editConfig: {
        type: 'select',
        options: browserTypes
      }
    },
    {
      display_name: "",
      key: "context_menu",
      _config: {
        type: 'contextMenu',
        icon: 'more_horiz',
        options: contextMenu
      },
      iconStyles: {
        color: 'grey'
      },
      headerStyles: {
        background: "#7593F2",
        width: '45px'
      }
    }
  ];
  
  export const validateApplicationDetail = [
    {
      key: "name",
      display_name: "Page Name",
      cellStyles: {
        ...cellStyles,
        'max-width': '200px',
        'word-break': 'break-word',
        'white-space': 'normal',
        'overflow': 'hidden',
        'text-overflow': 'ellipsis',
      },
      headerStyles: { ...headerStyle, width: '200px' },
      _editConfig: {
        type: 'input'
      }
    },
    {
      key: "url",
      display_name: "URL",
      cellStyles: {
        'max-width': '200px',
        'word-break': 'break-all',
        'white-space': 'normal',
        'overflow': 'hidden',
        'text-overflow': 'ellipsis',
      },
      headerStyles: { ...headerStyle, width: '200px' },
      _editConfig: {
        type: 'input'
      }
    },
    {
      display_name: "",
      key: "context_menu",
      _config: {
        type: 'contextMenu',
        icon: 'more_horiz',
        options: contextMenu
      },
      iconStyles: {
        color: 'grey'
      },
      headerStyles: {
        background: "#7593F2",
        width: '45px'
      }
    }
  ];

  export const validatePageeColumn: any = [
    {
      key: 'expand',
      showExpand: true,
      headerStyles: {
        background: "#7593F2",
        width: '30px'
      }
    },
    {
      display_name: "Object Name",
      key: "name",
      hideForChildren: true,
      cellStyles: {
        ...cellStyles,
        'padding-right': '15px !important',
        'max-width': '200px',
        'word-break': 'break-word',
        'white-space': 'normal',
        'overflow': 'hidden',
        'text-overflow': 'ellipsis',
      },
      headerStyles: {
        background: "#7593F2",
        width: '200px'
      },
      _editConfig: {
        type: 'input'
      }
    },
    {
      display_name: "Type",
      key: "type",
      hideByLevel: [0],
      headerStyles: {
        background: "#7593F2",
        width: '15%'
      },
      _editConfig: {
        type: 'select',
        options: paradigmTypes
      }
    },
    {
      display_name: "Locator",
      key: "locator",
      hideByLevel: [0],
      cellStyles: {
        'max-width': '150px',
        'word-break': 'break-all',
        'white-space': 'normal',
        'overflow': 'hidden',
        'text-overflow': 'ellipsis',
      },
      headerStyles: {
        background: "#7593F2",
        width: '150px'
      },
      _editConfig: {
        type: 'input'
      }
    },
    {
      display_name: "",
      key: "context_menu",
      _config: {
        type: 'contextMenu',
        icon: 'more_horiz',
        options: contextMenu
      },
      iconStyles: {
        color: 'grey'
      },
      headerStyles: {
        background: "#7593F2",
        width: '45px'
      }
    }
  ];

  export const validateServiceDetail = [
    {
      key: "name",
      display_name: "Name",
      cellStyles: {
        ...cellStyles,
        'max-width': '200px',
        'word-break': 'break-word',
        'white-space': 'normal',
        'overflow': 'hidden',
        'text-overflow': 'ellipsis',
      },
      headerStyles: { ...headerStyle, width: '200px' },
      _editConfig: {
        type: 'input'
      }
    },
    {
      key: "apiDefinitionId",
      display_name: "API Definition ID",
      headerStyles: { ...headerStyle },
      _editConfig: {
        type: 'input'
      }
    },
    {
      key: "url",
      display_name: "URL",
      cellStyles: {
        'max-width': '200px',
        'word-break': 'break-all',
        'white-space': 'normal',
        'overflow': 'hidden',
        'text-overflow': 'ellipsis',
      },
      headerStyles: { ...headerStyle, width: '200px' },
      _editConfig: {
        type: 'input'
      }
    },
    {
      display_name: "",
      key: "context_menu",
      _config: {
        type: 'contextMenu',
        icon: 'more_horiz',
        options: contextMenu
      },
      iconStyles: {
        color: 'grey'
      },
      headerStyles: {
        background: "#7593F2",
        width: '45px'
      }
    }
  ];

  export const validateServiceOperationDetail = [
    {
      key: "name",
      display_name: "Name",
      cellStyles: { ...cellStyles },
      headerStyles: headerStyle,
      _editConfig: {
        type: 'input'
      }
    },
    {
      key: "type",
      display_name: "Type",
      headerStyles: { ...headerStyle },
      _editConfig: {
        type: 'input'
      }
    },
    {
      key: "acceptType",
      display_name: "Accept Type",
      headerStyles: { ...headerStyle },
      _editConfig: {
        type: 'input'
      }
    },
    {
      key: "complexReturnType",
      display_name: "Complex Return Type",
      headerStyles: { ...headerStyle },
      _editConfig: {
        type: 'input'
      }
    },
    {
      key: "returnType",
      display_name: "Return Type",
      headerStyles: { ...headerStyle },
      _editConfig: {
        type: 'input'
      }
    },
    {
      key: "url",
      display_name: "URL",
      headerStyles: { ...headerStyle },
      _editConfig: {
        type: 'input'
      }
    },
    {
      display_name: "",
      key: "context_menu",
      _config: {
        type: 'contextMenu',
        icon: 'more_horiz',
        options: contextMenu
      },
      iconStyles: {
        color: 'grey'
      },
      headerStyles: {
        background: "#7593F2",
        width: '45px'
      }
    }
  ];

  export const validateServiceParamDetail = [
    {
      key: "name",
      display_name: "Name",
      cellStyles: { ...cellStyles },
      headerStyles: headerStyle,
      _editConfig: {
        type: 'input'
      }
    },
    {
      key: "paramType",
      display_name: "Parameter Type",
      headerStyles: { ...headerStyle },
      _editConfig: {
        type: 'input'
      }
    },
    {
      key: "type",
      display_name: "type",
      headerStyles: { ...headerStyle },
      _editConfig: {
        type: 'input'
      }
    },
    {
      display_name: "",
      key: "context_menu",
      _config: {
        type: 'contextMenu',
        icon: 'more_horiz',
        options: contextMenu
      },
      iconStyles: {
        color: 'grey'
      },
      headerStyles: {
        background: "#7593F2",
        width: '45px'
      }
    }
  ];

  export const validateSchemaDetail = [
    {
      key: "name",
      display_name: "Name",
      cellStyles: { ...cellStyles },
      headerStyles: headerStyle,
      _editConfig: {
        type: 'input'
      }
    },
    {
      key: "dataType",
      display_name: "Data Type",
      headerStyles: { ...headerStyle },
      _editConfig: {
        type: 'input'
      }
    },
    {
      display_name: "",
      key: "context_menu",
      _config: {
        type: 'contextMenu',
        icon: 'more_horiz',
        options: contextMenu
      },
      iconStyles: {
        color: 'grey'
      },
      headerStyles: {
        background: "#7593F2",
        width: '45px'
      }
    }
  ];
  